var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    height: _vm.defaultHeight + 'px',
    width: '100%'
  }),attrs:{"id":"sound-container"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"loading"},[_c('spinner')],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],staticClass:"file-name"},[_vm._v(" "+_vm._s(_vm.fileName)+" ")]),_c('div',{attrs:{"id":"waveform"}})])}
var staticRenderFns = []

export { render, staticRenderFns }